<template>
  <div class="first column justify-center align-center">
    <img :src="modal.theme.logo" width="100" /><br />
    <div class="title">
      Bem-vindo ao {{ modal.theme.text.name || "seu ambiente de atendimento" }}
    </div>
    <div class="frame row">
      <div class="frame-1" v-if="pass['1']">
        <img src="../../../assets/img/remote/passo1.png" />
        <div class="text">
          <div class="focus">Escolha um canal para atendimento</div>
          <p>
            Você pode escolher seu canal de preferência dentre várias opções,
            como WhatsApp, Telegram, Messenger, etc.
          </p>
        </div>
        <div class="pager">
          <svg
            width="30"
            height="5"
            viewBox="0 0 30 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="10" height="5" rx="2.5" class="bot" />
            <rect x="15" width="5" height="5" rx="2.5" class="bot" />
            <rect x="25" width="5" height="5" rx="2.5" class="bot" />
          </svg>
        </div>
      </div>
      <div class="frame-2" v-if="pass['2']">
        <div class="row justify-center">
          <div class="label">Passo 1</div>
        </div>

        <div class="text align-center column">
          <div class="focus">
            Conte seu problema para
            {{ user.genero_bot_km + " " + user.nome_bot_km }}!
          </div>
          <p>
            {{
              modal.theme.text.first ||
              "Nossa assistente virtual está pronta para te ajudar. Caso necessário, ela conectará você com um de nossos especialistas."
            }}
          </p>
        </div>
        <div class="pager">
          <svg
            width="30"
            height="5"
            viewBox="0 0 30 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="10" height="5" rx="2.5" class="bot" />
            <rect x="15" width="5" height="5" rx="2.5" class="bot" />
            <rect x="25" width="5" height="5" rx="2.5" class="bot" />
          </svg>
          <!--   <svg
            width="30"
            height="5"
            viewBox="0 0 30 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="20"
              y="5"
              width="10"
              height="5"
              rx="2.5"
              transform="rotate(-180 20 5)"
              class="bot"
            />
            <rect
              x="5"
              y="5"
              width="5"
              height="5"
              rx="2.5"
              transform="rotate(-180 5 5)"
              class="bot"
            />
            <rect x="25" width="5" height="5" rx="2.5" class="bot" />
          </svg> -->
        </div>
      </div>
      <div class="frame-3" v-if="pass['3']">
        <div class="row justify-center">
          <div class="label">Passo 2</div>
        </div>

        <div class="text">
          <div class="focus">Avalie o atendimento!</div>
          <p>
            Para melhorarmos sempre é muito importante que você avalie o
            atendimento que recebeu d{{ user.genero_bot_km }}
            {{ user.nome_bot_km }} e dos nossos especialistas!
          </p>
        </div>
        <div class="pager">
          <svg
            width="30"
            height="5"
            viewBox="0 0 30 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="20"
              y="3.05176e-05"
              width="10"
              height="5"
              rx="2.5"
              class="bot"
            />
            <rect
              x="5"
              y="5.00006"
              width="5"
              height="5"
              rx="2.5"
              transform="rotate(-180 5 5.00006)"
              class="bot"
            />
            <rect
              x="15"
              y="5"
              width="5"
              height="5"
              rx="2.5"
              transform="rotate(180 15 5)"
              class="bot"
            />
          </svg>
        </div>
      </div>
    </div>
    <Button layout="remote-continue" class="button-continue" @click="next()"
      >CONTINUAR</Button
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Button from "@/components/Button";

export default {
  props: { modal: Object },
  components: { Button },
  data() {
    return {
      pass: {
        n: 2,
        1: false,
        2: true,
        3: false,
      },
    };
  },
  methods: {
    next() {
      let pass = {
        n: this.pass.n + 1,
        1: false,
        2: false,
        3: false,
      };
      this.pass = pass;
      this.pass[pass.n] = true;
      if (this.pass.n == 4) {
        this.modal.show = false;
        let help = document.getElementById("help");
        if (window.getComputedStyle(help).display !== "none") help.click();
      }
    },
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.first {
  width: 300px;
  padding: 32px 15px;
  padding-bottom: 15px;
  text-align: center;
  font-family: Work Sans;

  @media (max-width: $small) {
    width: auto;
  }

  .logo {
    margin-bottom: 24px;
  }
  .title {
    font-weight: 600;
    font-size: 22px;
    line-height: 24px;
    margin-bottom: 12px;
  }
  .text {
    margin-top: 26px;
  }
  .pager {
    margin: 20px 0px;
  }
  .frame {
    overflow: hidden;

    .label {
      font-size: 10px;
      line-height: 20px;
      border-radius: 40px;
      color: white;
      width: 80px;
    }
  }
}
</style>